import { useEffect, useRef } from 'react';
import { Check, Pipette } from 'lucide-react';
import { colorSelection, PRESET_COLORS } from './richText';

const stop = (e) => e.preventDefault();

export const RichTextToolbar = ({ el, zoom, getRoot, onDone }) => {
  const rangeRef = useRef(null);

  useEffect(() => {
    const save = () => {
      const root = getRoot();
      const sel = window.getSelection();
      if (!root || !sel || sel.rangeCount === 0) return;
      const r = sel.getRangeAt(0);
      if (root.contains(r.commonAncestorContainer)) rangeRef.current = r.cloneRange();
    };
    document.addEventListener('selectionchange', save);
    return () => document.removeEventListener('selectionchange', save);
  }, [getRoot]);

  const apply = (color) => {
    const root = getRoot();
    if (!root) return;
    rangeRef.current = colorSelection(root, color, rangeRef.current);
  };

  const top = Math.max(4, el.y * zoom - 52);
  const left = Math.max(4, Math.min(el.x * zoom, Math.max(4, el.w * zoom + el.x * zoom - 300)));

  return (
    <div
      data-rich-toolbar="true"
      data-testid="rich-text-toolbar"
      onMouseDown={stop}
      onTouchStart={(e) => e.stopPropagation()}
      className="absolute z-30 flex items-center gap-1 rounded-full border border-white/[0.12] bg-[#0f0f11]/95 px-1.5 py-1 shadow-xl backdrop-blur"
      style={{ top, left }}
    >
      <span className="hidden px-1 text-[10px] font-semibold uppercase tracking-wider text-[#71717a] sm:inline">Highlight words →</span>
      {PRESET_COLORS.map((c) => (
        <button
          key={c}
          type="button"
          title={c}
          data-testid={`rich-color-${c.replace('#', '')}`}
          onMouseDown={stop}
          onClick={() => apply(c)}
          className="h-6 w-6 shrink-0 rounded-full border border-white/20 transition-transform hover:scale-110 active:scale-95"
          style={{ background: c }}
        />
      ))}
      <label className="relative flex h-6 w-6 shrink-0 cursor-pointer items-center justify-center rounded-full border border-dashed border-white/30 text-[#a1a1aa] hover:text-white" title="Custom colour" onMouseDown={stop}>
        <Pipette className="h-3 w-3" />
        <input
          type="color"
          data-testid="rich-color-custom"
          className="absolute inset-0 h-full w-full cursor-pointer opacity-0"
          onMouseDown={(e) => e.stopPropagation()}
          onChange={(e) => apply(e.target.value)}
        />
      </label>
      <button
        type="button"
        data-testid="rich-text-done-btn"
        onMouseDown={stop}
        onClick={onDone}
        className="ml-1 flex h-6 items-center gap-1 rounded-full bg-[#EAB308] px-2 text-[11px] font-bold text-black"
      >
        <Check className="h-3 w-3" /> Done
      </button>
    </div>
  );
};
